import { section } from '@/glow';
import { on } from '@/glow/events';
import Carousel from '@/lib/carousel';

section('featured-collection-row', {
  events: [],
  onLoad() {
    this.carousel = Carousel(this.container, 'featured-collection-row', {
      wrapAround: false,
      adaptiveHeight: false,
    });

    this.events.push(
      on('featured-collection-row:initialized', () => {
        if (!window.matchMedia('(min-width: 45em)').matches) {
          this.carousel.select(1);
        }
      })
    );
  },

  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
    this.carousel && this.carousel.destroy();
  },
});
